<form [formGroup]="form">
  <ng-container formGroupName="timeCardSettings">
    <div class="mb-lg">
      <label>{{ 'MAP-DISPLAY.TIME-FORMAT' | translate }}</label>
      <div class="radio-list">
        <label class="radio">
          <input
            type="radio"
            [value]="timeFormatShort"
            name="timeFormat"
            formControlName="timeFormat" />
          {{ timeFormatShortSample }}&nbsp;{{ 'MAP-DISPLAY.TIME-12-SAMPLE' | translate }}
        </label>
        <label class="radio">
          <input
            type="radio"
            [value]="timeFormat24h"
            name="timeFormat"
            formControlName="timeFormat" />
          {{ timeFormat24hSample }}&nbsp;{{ 'MAP-DISPLAY.TIME-24-SAMPLE' | translate }}
        </label>
      </div>
    </div>

    <div>
      <label>{{ 'MAP-DISPLAY.ORDER-BY-LONGTITUDE' | translate }}</label>
      <topo-switch formControlName="orderByLongitude" />
    </div>
  </ng-container>
</form>
